module.exports = __webpack_public_path__ + "media/images/countrysquared/id-54cb7a59fe83d5292ffa192f1d708338.svg";